export default "__VITE_ASSET__MwdLlmxI__"